'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { capiTrack } from '../server/tracking';
export function TrackPageView(t0) {
  const $ = _c(3);
  const {
    pathname
  } = t0;
  const tracked = useRef(false);
  let t1;
  let t2;
  if ($[0] !== pathname) {
    t1 = () => {
      if (!tracked.current) {
        capiTrack("PageView", {}, {
          pathname
        }).catch(_temp);
        tracked.current = true;
      }
    };
    t2 = [pathname];
    $[0] = pathname;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}
function _temp() {}